/* ==========================================================================
   MyAthanClock — Setup Page JS
   Mark-complete toggles, progress bar, side-nav scroll spy,
   celebrate reveal, next-prayer countdown.
   ========================================================================== */

(function(){
  'use strict';

  const section = document.querySelector('.mys-section');
  if (!section) return;

  const TOTAL_STEPS = section.querySelectorAll('.mys-step').length;
  const completed = new Set();
  let currentVisible = 1;

  const progressFill = section.querySelector('[data-mys-progress-fill]');
  const progressPct = section.querySelector('[data-mys-progress-pct]');
  const stepCounter = section.querySelector('[data-mys-step-counter]');
  const celebrate = section.querySelector('[data-mys-celebrate]');
  const sideNavLis = section.querySelectorAll('.mys-side-nav li[data-step]');

  // ---------- Mark-complete buttons ----------
  section.querySelectorAll('[data-mys-complete]').forEach(btn => {
    btn.addEventListener('click', () => {
      const id = parseInt(btn.dataset.mysComplete, 10);
      if (completed.has(id)){
        completed.delete(id);
        btn.classList.remove('done');
        btn.innerHTML = 'Mark as done <span class="arrow">→</span>';
      } else {
        completed.add(id);
        btn.classList.add('done');
        btn.innerHTML = '✓ Done';
      }
      updateProgress();

      // Auto-scroll to next step if completed
      if (completed.has(id) && id < TOTAL_STEPS){
        setTimeout(() => {
          const next = section.querySelector('[data-mys-step="' + (id + 1) + '"]');
          if (next) next.scrollIntoView({ behavior: 'smooth' });
        }, 400);
      }

      // Show celebrate when all done
      if (completed.size === TOTAL_STEPS && celebrate){
        celebrate.classList.add('show');
        setTimeout(() => celebrate.scrollIntoView({ behavior: 'smooth' }), 400);
      } else if (celebrate){
        celebrate.classList.remove('show');
      }
    });
  });

  function updateProgress(){
    const pct = Math.round((completed.size / TOTAL_STEPS) * 100);
    if (progressFill) progressFill.style.width = pct + '%';
    if (progressPct) progressPct.textContent = pct + '%';

    sideNavLis.forEach(li => {
      const step = parseInt(li.dataset.step, 10);
      li.classList.toggle('done', completed.has(step));
    });
  }

  // ---------- Side nav click → scroll to step ----------
  sideNavLis.forEach(li => {
    li.addEventListener('click', () => {
      const step = li.dataset.step;
      const target = section.querySelector('[data-mys-step="' + step + '"]');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  // ---------- Scroll spy ----------
  const stepEls = Array.from(section.querySelectorAll('.mys-step[data-mys-step]'));
  function onScroll(){
    const offset = window.innerHeight / 3;
    let activeIdx = 0;
    stepEls.forEach((el, i) => {
      const r = el.getBoundingClientRect();
      if (r.top < offset) activeIdx = i;
    });
    if (!stepEls[activeIdx]) return;
    const activeStep = parseInt(stepEls[activeIdx].dataset.mysStep, 10);
    if (activeStep !== currentVisible){
      currentVisible = activeStep;
      sideNavLis.forEach(li => {
        const step = parseInt(li.dataset.step, 10);
        li.classList.toggle('active', step === activeStep && !li.classList.contains('done'));
      });
      if (stepCounter) stepCounter.textContent = activeStep;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ---------- Lazy YouTube embed (click thumbnail to play) ----------
  const videoFrame = section.querySelector('[data-mys-video]');
  if (videoFrame){
    videoFrame.addEventListener('click', () => {
      const vid = videoFrame.dataset.mysVideo;
      if (!vid) return;
      const iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + vid + '?autoplay=1&rel=0';
      iframe.title = 'Setup video';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.setAttribute('allowfullscreen', '');
      videoFrame.innerHTML = '';
      videoFrame.appendChild(iframe);
    });
  }

  // ---------- Gentle 00:00 flicker on the clock device illustration ----------
  const deviceScreen = section.querySelector('[data-mys-device-screen]');
  if (deviceScreen){
    setInterval(() => {
      deviceScreen.style.opacity = deviceScreen.style.opacity === '0.55' ? '1' : '0.55';
    }, 1100);
  }

  // ---------- Next-prayer card on celebrate ----------
  const celebrateTime = section.querySelector('[data-mys-celebrate-time]');
  const celebrateSub = section.querySelector('[data-mys-celebrate-sub]');
  if (celebrateTime || celebrateSub){
    const PRAYERS = [
      { name: 'Fajr',    h: 5,  m: 42 },
      { name: 'Dhuhr',   h: 13, m: 8 },
      { name: 'Asr',     h: 16, m: 31 },
      { name: 'Maghrib', h: 19, m: 14 },
      { name: 'Isha',    h: 20, m: 43 }
    ];
    function updateCelebrate(){
      const now = new Date();
      const curr = now.getHours() * 60 + now.getMinutes();
      const next = PRAYERS.find(p => (p.h * 60 + p.m) > curr) || PRAYERS[0];
      const timeStr = String(next.h).padStart(2,'0') + ':' + String(next.m).padStart(2,'0');
      if (celebrateTime) celebrateTime.textContent = next.name + ' · ' + timeStr;
      let diff = (next.h * 60 + next.m) - curr;
      if (diff < 0) diff += 1440;
      const h = Math.floor(diff / 60), m = diff % 60;
      const city = celebrateSub ? (celebrateSub.dataset.mysCity || 'Toronto') : 'Toronto';
      if (celebrateSub) celebrateSub.textContent = 'in ' + h + 'h ' + m + 'm · ' + city;
    }
    updateCelebrate();
    setInterval(updateCelebrate, 30000);
  }

})();